var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLlpConfig = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2,2.12 L 14.07,2.12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 2,21.88 L 14.07,21.88",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.65,2.12 L 3.65,5.96 L 8.04,12 L 3.65,18.04 L 3.65,21.88",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.43,2.12 L 12.43,5.96 L 8.04,12 L 12.43,18.04 L 12.43,21.88",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.39,19.13 L 9.68,19.13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.92,10.9 C 18.43,10.9 18.78,11.41 18.78,12.08 L 18.78,14.22 L 22,16.06 L 22,17.08 L 18.78,16.16 L 18.78,18 L 19.8,18.82 L 19.8,19.68 L 17.92,19.17 L 16.03,19.68 L 16.03,18.82 L 17.05,18 L 17.05,16.16 L 13.83,17.08 L 13.83,16.06 L 17.05,14.22 L 17.05,12.08 C 17.05,11.41 17.41,10.9 17.92,10.9 L 17.92,10.9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLlpConfig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/llp-config.9d059f38.svg";
export { ForwardRef as ReactComponent };